import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchTerminals } from "../actions/terminal";
import { fetchSettings } from "../actions/setting";
import { fetchOsSettings } from "../actions/ossetting";
import { fetchAccounts } from "../actions/account";
import { login } from "../actions/user";
import AccountEdit from "../components/AccountEdit";

const mapStateToProps = (state) => {
   const { setting } = state;
   const { account } = state;
   const { isFetching, lastUpdated, totalRows } = account || {
      isFetching: true,
   };

   const usersMaster = setting.items || [];

   return {
      isFetching,
      lastUpdated,
      totalRows,
      usersMaster,
   };
};

const mapDispatchToProps = (dispatch) =>
   bindActionCreators(
      {
         getAccounts: fetchAccounts,
         getTerminals: fetchTerminals,
         getSettings: fetchSettings,
         getOsSettings: fetchOsSettings,
         login: login,
      },
      dispatch
   );

export default connect(mapStateToProps, mapDispatchToProps)(AccountEdit);
